module.exports = __webpack_public_path__ + "img/49.30cd1f11.jpg";